import { defineStore } from 'pinia';
import { ref } from 'vue';
import { Institution } from '../../shared/types';
import { genericAdminService } from '../../shared/services/api/genericAdmin.service';

export const useAdminStore = defineStore('adminStore', () => {
  const institutions = ref<Institution[]>([]);

  const fetch = async () => {
    institutions.value = (await genericAdminService.getInstitutions()).map(institution => ({
      ...institution,
      institutionType: institution.type,
    }));
  };

  return {
    institutions,
    fetch,
  };
});
